export const lang = {
  copySuccess: 'The share link has been copied to the clipboard',
  copyFail: 'Copy share link failed',
  invalidFile: 'File not supported',
  invalidType: 'The imported file format is not supported',
  invalidSize: 'The file size is over 30 megabytes',
  inputFileType: 'Supported formats: JPG, PNG, SVG, PDF, PSD, AI, GIF, TIF, HEIC, webp',
  inputFileSize: 'Size limit: 30M',
  inputFileLimit: 'File requirements: AI format document need to embed all the pictures, fonts and other materials used.',
  cameraTitle: 'Camera',
  cameraSubTitle: 'Switch to App to Take a Photo for Design',
  selectFile: 'Select File',
  labelPixel: 'pixel',
  labelWidth: 'width',
  labelHeight: 'height',
  labelRatio: 'ratio',
  labelSun: 'parasol',
  labelRain: 'umbrella',
  titleRotate: 'rotate',
  titleZoom: 'zoom',
  titleCamera: 'capture',
  titleGallery: 'gallery',
  titlePatterns: 'patterns',
  titleHelp: 'help',
  titleBack: 'back',
  titleAddLogo: 'add logo',
  titleAddText: 'add text',
  titleUmbOpen: 'umbrella frame',
  titleUmbFold: 'umbrella in fold',
  titleUmbSleeve: 'umbrella with sleeve',
  titleUmbHandle: 'umbrella handle',
  titleDesignSleeve: 'design umbrella overcase pouch',
  titleAddToCart: 'add to cart',
  titleShare: 'share design',
  title3D: '3D preview',
  titleCart: 'shop cart',
  titleHome: 'home',
  titleProductUmb: 'umbrella',
  titleProductScarf: 'silk scarf',
  titleProductGift: 'gift',
  titleProductBag: 'bag',
  cameraPermission: 'Please go to system Settings to turn on camera permissions',
  libraryPermission: 'Please go to system Settings to open album permissions',
  placeholderText: 'Please enter text',
  titleGetCode: 'verify code',
  titleGuest: 'guest',
  titlePhone: 'enter phone number',
  titleCode: 'enter code',
  titleLogin: 'Login',
  titleOtherLogin: 'other ways',
  titleDeal: 'Login means agree',
  titleUserAgreement: 'User Agreement',
  titlePrivacyPolicy: 'Privacy policy',
  titleErrorPhone: 'phone number invalid',
  titleErrorCode: 'code invalid',
  labelDownloadApp: 'download app',
  labelStartDesign: 'start design',
  labelAccountLogin: 'login',
  labelQuickLogin: 'quick login',
  labelForget: 'forget password',
  labelRegister: 'register',
  labelConfirm: 'confirm',
  labelRetrieve: 'retrieve password',
  labelHasAccount: 'existing account',
  labelPassword: 'enter password',
  labelNewPassword: 'enter new passsword',
  labelNoRegister: 'no account',
  labelSaveSuccess: 'upload success',
  labelSaveFail: 'upload fail',
  alreadySave: 'already uploaded',
  confirmSleeve: 'confirm design for overcase',
  reDesignSleeve: 'design',
  defaultDesignSleeve: '<div>confirm</div>',
  defaultText: 'edit text',
  clear: 'clear',
  warningClear: 'Can not recover after Clear !',
  confirmClear: 'clear',
  cancel: 'cancel',
  remove: 'Confirm Remove?',
  warningRemove: ' Can not recover after Remove !',
  confirmRemove: 'remove',
  product_umb: 'umbrella',
  product_scarf: 'silk scarf',
  product_mask: 'facemask',
  save: 'upload again',
  orderIdTitle: 'No.',
  buy: 'Buy',
  inputImageFail: 'Import image failed'
}
